import axios from "axios";
import { BASE_URL } from "../../util/Constants";
import { isEmpty, normalizarEmail } from "../../util/Functions";
import HTTP from "../../util/Http";
import {
  getCredentialsLS,
  getUserLoggedLS,
  setUserLoggedLS,
} from "../../util/LocalStorageUtils";

export async function loginUser(credentials) {
  const url = BASE_URL + "usuario/login";
  const email = normalizarEmail(credentials?.email);
  const payload = { email, password: credentials?.password };
  return fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then((data) => data.json());
}

export async function getUsuariosDTO(setUsuariosDTO) {
  const url = BASE_URL + "usuarios/DTO";
  await HTTP.get(url).then((response) => setUsuariosDTO(response.data));
}

export async function cambiarPassword(usuarioId, passwordActual, nuevaPassword) {
  const url = BASE_URL + "usuario/cambiar-password";
  const data = {
    usuarioId,
    passwordActual,
    nuevaPassword,
  };
  const response = await HTTP.post(url, data);
  return response.data;
}

export function getToken() {
  var userLogged = getUserLoggedLS();
  return userLogged?.token;
}

export function logOut() {
  // window.location.href = "/signin";
  // setUserLoggedLS(null);
}

export async function refreshToken() {
  var credentials = getCredentialsLS();
  var response = null;
  if (!isEmpty(credentials)) {
    response = loginUser(credentials);
  }
  return response;
}

export function setUser(userLogged) {
  setUserLoggedLS(userLogged);
}

export const solicitarAcceso = async (email, handleResponse) => {
  const url = BASE_URL + "usuario/solicitaracceso";
  const userAccessRequest = {
    email: email,
  };

  const peticion = await axios.post(url, userAccessRequest);
  const res = peticion.data;
  console.log(res);
  handleResponse(res);
};
